import { connect } from 'react-redux';

import getBaseOffersPageProps from 'components/Offers/utils/get-base-properties';

import { offersFetcher } from 'redux/fetchers/offers';

import OffersPage from 'components/Offers/OffersPage/OffersPage';
import { withRouteProps } from 'utils/with-route-props';

export default withRouteProps(
  connect(
    (state, props) => ({
      ...getBaseOffersPageProps(state, props),
      offerType: props?.match?.params?.offerIdentifier,
    }),
    (dispatch, props) => ({
      fetchOfferProducts: () => {
        dispatch(
          offersFetcher({
            ...props,
            match: { params: { offerType: props?.match?.params?.offerIdentifier } },
          }),
        );
      },
    }),
  )(OffersPage),
);
